import { Injectable, Inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    // Check if on logged-out page - always allow
    if (state.url.includes('/logged-out')) {
      return true;
    }

    // Check authentication
    const isAuthenticated = await this.oktaAuth.isAuthenticated();

    if (!isAuthenticated) {
      // Store the attempted URL for redirecting after login
      this.oktaAuth.setOriginalUri(state.url);

      // Redirect to Okta for authentication
      await this.oktaAuth.signInWithRedirect();

      // Return false since we're redirecting
      return false;
    }

    return true;
  }
}
